import instance from './instance'

const couponUrl = 'modules-coupon/coupons'

export const getCouponList = (page: number, pageSize: number, filterKey: any) =>
  instance.get(`${couponUrl}?page=${page}&pageSize=${pageSize}&filterkey=${filterKey}`)

export const getCouponById = (id: number) => instance.get(`${couponUrl}/${id}`)

export const getDownloadCouponById = (id: number, gridSize: string) => {
  const url = `modules-coupon/download-coupon/${id}?grid_size=${encodeURIComponent(gridSize)}`
  console.log('=== API Service Call ===');
  console.log('URL:', url);
  console.log('Grid Size Parameter:', gridSize);
  // Send grid_size as query parameter for GET request
  return instance.get(url)
}

export const createCoupon = (payload: any) => instance.post(couponUrl, payload)

export const updateCoupon = (id: number, payload: any) =>
  instance.post(`${couponUrl}/${id}`, payload)

export const deleteCoupon = async (id: number) => await instance.delete(`${couponUrl}/${id}`)
